// extracted by mini-css-extract-plugin
export var subtitle = "styles-module--subtitle--e7206";
export var title = "styles-module--title--abc26";
export var wrapper = "styles-module--wrapper--56860";